module.exports = __webpack_public_path__ + "static/media/Impreza-GD-Sedan.026e7a53.jpg";